module.exports = __webpack_public_path__ + "static/img/lie.71b4fe4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lie.svg
// module id = FnKY
// module chunks = 0